import React, { FC } from 'react'
import { NextRouter } from 'next/router'
import HoneyPotForm from './HoneyPotForm'
import HoneyPotLink from './honeypotLink'
import parse from 'lib/url/parse'
import { getPagePath } from 'selectors/page'
import { Page } from 'types/Page'

type InitialState = {
  page: Page
}

type AppHoneyPotProps = {
  initialState: InitialState
  router?: NextRouter
}

const AppHoneyPot: FC<AppHoneyPotProps> = ({ initialState, router }) => {
  const urlPath = router?.asPath || getPagePath(initialState)
  const { pathname: path } = parse(urlPath)

  let cleanPath = path
  if (cleanPath.match(/.*[/]$/)) {
    cleanPath = cleanPath.replace(/\/$/, '')
  }

  if (cleanPath === '/facsimile-npc') {
    return null
  }

  return (
    <>
      <HoneyPotForm />
      <HoneyPotLink />
    </>
  )
}

export default AppHoneyPot
